<script>
import AppForm from '../components/AppForm';
import getFieldErrors from '../getFieldErrors';
import ChallengeLoader from '../components/ChallengeLoader';

export default {
  name: 'SignatureSmartId',
  components: {
    AppForm,
    ChallengeLoader,
  },
  data() {
    return {
      fieldErrors: {},
      challenge: undefined,
      authProcess: {},
    }
  },
  computed: {
    inputValues() {
      return this.$root.$options.storeGetters.inputValues();
    },
    additionalMethodConfig() {
      return this.$root.$options.storeGetters.additionalMethodConfig();
    },
    schema() {
      return  [
        {
          type: 'text',
          name: 'idcode',
          label: this.$t('idcode'),
          validation: ['required'],
        },
        {
          type: 'submit',
          label: this.$t('Sign')
        }
      ]
    },
    formValue: {
      get() {
        return {
          idcode:  this.inputValues.idcode,
        }
      },
      set(newValues){
        this.updateInputValues(newValues);
      }
    },
  },
  methods: {
    updateInputValues(newValues) {
      this.$root.$options.storeActions.updateInputValues(newValues);
    },
    loadingStart() {
      this.$root.$options.storeActions.loadingStart();
    },
    loadingEnd() {
      this.$root.$options.storeActions.loadingEnd();
    },
    addFlashMessage(message) {
      this.$root.$options.storeActions.addFlashMessage(message);
    },
    clearFlashMessages() {
      this.$root.$options.storeActions.clearFlashMessages();
    },
    startSignatureProcessing() {
      this.$root.$options.storeActions.startSignatureProcessing();
    },
    endSignatureProcessing() {
      this.$root.$options.storeActions.endSignatureProcessing();
    },
    clearErrors() {
      this.fieldErrors = {};
    },
    cancel() {
      const {cancel} = this.authProcess;
      if (cancel) {
        cancel();
      }
    },
    sign() {
      this.loadingStart();
      this.clearFlashMessages();
      this.clearErrors();
      const additionalMethodConfig = this.additionalMethodConfig || {};
      this.authProcess = this.$root.$options.eidEasyClient.signature.smartIdSignature.start({
        ...this.formValue,
        started: (result) => {
          if (result.data && result.data.challenge) {
            this.challenge = result.data.challenge;
            this.loadingEnd();
            this.startSignatureProcessing();
          }
        },
        fail: (error) => {
          if (!error.isCancel) {
            this.addFlashMessage(error);
          }
          this.fieldErrors = getFieldErrors(error);
          this.$root.$options.eidEasyOnFail(error);
        },
        success: (result) => {
          this.$root.$options.eidEasyOnSuccess(result);
        },
        finished: () => {
          this.challenge = undefined;
          this.endSignatureProcessing();
          this.loadingEnd();
        },
        ...additionalMethodConfig,
      });
    }
  },
}
</script>

<template>
  <div :class="$style.formContainer">
    <div
      v-if="challenge"
      :class="$style.challenge"
    >
      <ChallengeLoader :challenge="challenge" />
    </div>
    <div v-else>
      <AppForm
        id="smartIdSignatureForm"
        v-model="formValue"
        :schema="schema"
        :on-submit="sign"
        :errors="fieldErrors"
      />
    </div>
  </div>
</template>

<style lang="scss" module>
.formContainer {
  max-width: $form-container-width;
  margin: 0 auto;
}
</style>
